import React from 'react';
import { useParams } from 'react-router-dom';

const EntityTypeFormBuilder = () => {
  const { id } = useParams();

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Form Builder</h2>
      <p>Entity type ID: {id}</p>
      <p>Form Builder is coming soon.</p>
    </div>
  );
};

export default EntityTypeFormBuilder;
